import {Injectable} from '@angular/core';
import {WorkObservations} from './work-observations.model';
import {Service} from '../../common/service.class';
import {UserModelService} from '../../common/user-model.service';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class WorkObservationsService extends UserModelService<WorkObservations> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'workObservations', WorkObservations);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/observations/work-observations.service.ts